"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermission = void 0;
var globalDialogConfig = {
    Geolocation: {
        title: "定位服务未开启",
        content: "若您想启用定位服务,请在系统设置中开启海马体照相馆定位权限",
        confirm: "开启",
        cancel: "取消",
    },
    Album: {
        title: "相册服务未开启",
        content: "若您想保存照片至相册,请在系统设置中开启海马体照相馆相册权限",
        confirm: "开启",
        cancel: "取消",
    },
    Camera: {
        title: "无法使用相机",
        content: "若您想使用相机,请在系统设置中开启海马体照相馆相机权限",
        confirm: "开启",
        cancel: "取消",
    },
    File: {
        title: "无法读取存储",
        content: "若您想更换头像,请在系统设置中开启读取存储权限",
        confirm: "开启",
        cancel: "取消",
    },
};
var androidPermissions = {
    Camera: "android.permission.CAMERA",
    Geolocation: "android.permission.ACCESS_FINE_LOCATION",
    Record: "android.permission.RECORD_AUDIO",
    File: "android.permission.READ_EXTERNAL_STORAGE",
    iBeacon: "android.permission.BLUETOOTH",
    Messaging: "android.permission.RECEIVE_SMS",
    Barcode: "android.permission.CAMERA",
    Storage: "android.permission.WRITE_EXTERNAL_STORAGE",
    Share: "android.permission.WRITE_EXTERNAL_STORAGE",
    Album: "android.permission.READ_EXTERNAL_STORAGE", // 访问系统相册权限
};
function androidPermissionsCheck(feature) {
    var permission = androidPermissions[feature];
    if (permission) {
        // @ts-ignore
        window.plus.android.requestPermissions([permission], function (result) {
            var isGranted = result.deniedPresent.length <= 0 && result.deniedAlways.length <= 0;
            if (!isGranted) {
                var lauchWebview = window.plus.webview.getLaunchWebview();
                var dialogConfig = globalDialogConfig[feature] || false;
                dialogConfig &&
                    lauchWebview.evalJS("window.globalRouter.showPermissionDialog(".concat(JSON.stringify(dialogConfig), ")"));
            }
            window.resolveCheckPermission(isGranted);
        });
    }
}
function checkPermission(feature, dialogOptions) {
    var lauchWebview = window.plus.webview.getLaunchWebview();
    var dialogConfig = dialogOptions || globalDialogConfig[feature] || {};
    return new Promise(function (resolve, reject) {
        // 定义全局回调函数
        window.resolveCheckPermission = function (res) {
            try {
                resolve(res);
            }
            catch (error) {
                reject(error);
            }
        };
        var isAndroid = window.plus.os.name === "Android";
        if (isAndroid) {
            androidPermissionsCheck(feature);
            return;
        }
        lauchWebview.evalJS("window.globalRouter.checkPermission('".concat(feature, "', ").concat(JSON.stringify(dialogConfig), ")"));
    });
}
exports.checkPermission = checkPermission;
//# sourceMappingURL=permission.js.map